module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result32-945ab70ce8a42e93cd32bba81c000094.png";